import React from "react";

import Select from "./index";

export const INVOICE_LINE_CATEGORIES = [
  "Design / Website Services",
  "Digital Services",
  "Digital Services [eBooks / email / Document Processing]",
  "IT Consultancy: [Architecture / Trouble Shooting / Planning]",
  "IT Consultancy: [Project Management / Team Management]",
  "SEO / Marketing / Data Processing",
  "Software: [Bespoke Development/Customisation]",
  "Software: [Implementation / Maintenance]",
  "System/Network Management",
];

export default function Category(props) {
  return <Select name="category" items={INVOICE_LINE_CATEGORIES} {...props} />;
}
